import { flatten, isEmpty } from "lodash";
import { assign, createMachine } from "xstate";
import { PaymentRequestStatus } from "../../PaymentContainerClient/commons/enums";
import PaymentRequestDto from "../../PaymentContainerClient/dtos/PaymentRequestDto";
import getFailedPaymentsWithDetailedInstallments from "../../ui/commons/getFailedPaymentsWithDetailedInstallments";
import getPaymentPlansMeaningfullForErrors from "../../ui/commons/getPaymentPlansMeaningfullForErrors";
import { getPaymentRequest } from "../usecases/getPaymentRequest";

interface Context {
    data?: PaymentRequestDto;
    isPaymentFailedModalOpen: boolean;
    error?: any;
}

export enum PaymentRequestMachineState {
    Idle = "idle",
    Loading = "loading",
    Success = "success",
    Failure = "failure",
}

export const paymentRequestMachine = createMachine<Context>({
    id: "paymentRequestMachine",
    initial: PaymentRequestMachineState.Idle,
    context: {
        data: undefined,
        isPaymentFailedModalOpen: false,
        error: undefined,
    },
    states: {
        [PaymentRequestMachineState.Idle]: {
            on: { FETCH: PaymentRequestMachineState.Loading },
        },
        [PaymentRequestMachineState.Loading]: {
            invoke: {
                src: (_, event) => getPaymentRequest(event.token),
                onDone: {
                    target: PaymentRequestMachineState.Success,
                    actions: [
                        assign({
                            data: (_, event) => event.data,
                        }),
                        assign({
                            isPaymentFailedModalOpen: (context, _event) => {
                                const paymentPlansMeaniningfullForErrors =
                                    getPaymentPlansMeaningfullForErrors(
                                        context.data!.availablePaymentPlans,
                                        context.data!.payments
                                    );

                                if (
                                    !isEmpty(
                                        getFailedPaymentsWithDetailedInstallments(
                                            flatten(
                                                paymentPlansMeaniningfullForErrors.map(
                                                    (paymentPlan) =>
                                                        paymentPlan.installments
                                                )
                                            ),
                                            context.data!.payments
                                        )
                                    ) &&
                                    context.data?.status !==
                                        PaymentRequestStatus.ExternalPaid &&
                                    context.data?.status !==
                                        PaymentRequestStatus.Paid
                                ) {
                                    return true;
                                }

                                return false;
                            },
                        }),
                    ],
                },
                onError: {
                    target: PaymentRequestMachineState.Failure,
                    actions: assign({
                        error: (_, event) => event.data,
                    }),
                },
            },
        },
        [PaymentRequestMachineState.Success]: {
            on: {
                CLOSE_PAYMENT_FAILED_MODAL: {
                    actions: assign({
                        isPaymentFailedModalOpen: (_context, _event) => false,
                    }),
                },
            },
        },
        [PaymentRequestMachineState.Failure]: {
            on: {
                RETRY: PaymentRequestMachineState.Loading,
            },
        },
    },
});
